module.exports = __webpack_public_path__ + "img/applause.487504e5.svg";